/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const YardIssueType = {
  Unknown: 'Unknown',
  DuplicatePosition: 'DuplicatePosition',
  ContainerInBlockedSlot: 'ContainerInBlockedSlot',
  StackHeightExceeded: 'StackHeightExceeded',
  ReeferContainerInUnpoweredSlot: 'ReeferContainerInUnpoweredSlot',
  NonReeferContainerInReeferSlot: 'NonReeferContainerInReeferSlot',
  FlyingContainer: 'FlyingContainer',
  AllocationRuleCapacityFull: 'AllocationRuleCapacityFull',
  BlockCapacityFull: 'BlockCapacityFull',
  YardCapacityFull: 'YardCapacityFull',
  ImdgStackingOnTopViolation: 'ImdgStackingOnTopViolation',
  ImdgTierCapViolation: 'ImdgTierCapViolation',
  ImdgSegregationViolation: 'ImdgSegregationViolation',
} as const

export type YardIssueType = (typeof YardIssueType)[keyof typeof YardIssueType]
